<template>
  <Layout>
    <DsIslandsContainer>
      <DsIsland align-center>
        <div class="flex justify-center mb-spacing-600">
          <DsIllustration name="status-service-error"
                          type="narrow" />
        </div>
        <div class="heading-200-accent text-center px-spacing-600"
             v-html="translate('new-year-unavailable:title')" />
        <div class="caption-700 text-center text-secondary mt-spacing-400 px-spacing-600"
             v-html="message"></div>
        <div class="mx-auto mt-spacing-600">
          <DsButton class="min-w-[192px]"
                    size="medium"
                    @click="onClick">
            <div class="label-600-soft">
              {{ 'new-year-unavailable:btn' | translate }}
            </div>
          </DsButton>
        </div>
      </DsIsland>
    </DsIslandsContainer>
  </Layout>
</template>

<script setup>
import { DsIsland, DsIslandsContainer, DsIllustration, DsButton } from '@ds/vue2';
import { eventBus } from 'kaspi.frontend/src/modules/eventBus/eventBus'
import { onMounted, computed } from 'vue';
import Layout from '@/components/ui/Layout/Layout.vue'
import translate from '@/filters/translate.filter'
import useStore from '@/composables/useStore'

const store = useStore();

const message = computed(() => {
  return store.getters["goldkidProcess/getErrorText"] || translate('error:text')
})

onMounted(() => {
  eventBus.$emit('kaspiLoading', false)
})
const onClick = () => {
  window.location.href = process.env.VUE_APP_BASE_URL
}
</script>
